module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/CommandCenter/images/command-center-lvl3-50.1b2dae7b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/CommandCenter/images/command-center-lvl3-50.png
// module id = 3277
// module chunks = 11